import { ToastContentProps } from "@lya-protect/lya-protect-form-library/dist/UI";
import classNames from "classnames";
import { InfoCard } from "@endya-conformite/ui-kit";
import style from "./toastContent.module.scss";

export function ToastContent({
  hideToast,
  level,
  message,
  className,
}: ToastContentProps) {
  return (
    <InfoCard
      type={level}
      className={classNames(className, style.toastContent)}
      onCancel={hideToast}
      cancelButtonClassName={style.cancelButton}
    >
      {message}
    </InfoCard>
  );
}
